import React, { useEffect, useState, useMemo } from "react";
import "./MultiSelectPopup.css";

const MultiSelectApiPopup = ({
  api,
  apiTitle,
  selectedValues = [],
  onClose,
  onChangeLive,
}) => {
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState([...selectedValues]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchOptions = async () => {
      try {
        const res = await fetch(api);
        const data = await res.json();
        if (isMounted) {
          setOptions(Array.isArray(data) ? data : []);
          setLoading(false);
        }
      } catch (err) {
        console.error("Failed to load options:", err);
        setLoading(false);
      }
    };

    fetchOptions();
    return () => {
      isMounted = false;
    };
  }, [api]);

  const getLabel = (item) =>
    item?.[apiTitle] || item?.name || item?.label || "Unnamed";

  const toggleSelect = (id) => {
    setSelected((prev) => {
      const updated = prev.includes(id)
        ? prev.filter((v) => v !== id)
        : [...prev, id];
      onChangeLive(updated);
      return updated;
    });
  };

  const selectAll = () => {
    const allIds = filteredOptions.map((item) => item._id);
    setSelected(allIds);
    onChangeLive(allIds);
  };

  const clearAll = () => {
    setSelected([]);
    onChangeLive([]);
  };

  const filteredOptions = useMemo(
    () =>
      options.filter((item) =>
        getLabel(item).toLowerCase().includes(search.toLowerCase())
      ),
    [options, search]
  );

  return (
    <div className="popup-overlay" role="dialog" aria-modal="true">
      <div className="popup-content">
        <header className="popup-header">
          <h3 className="popup-title">Select {apiTitle}</h3>
        </header>

        {/* Search */}
        <input
          type="text"
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="form-input popup-search"
          aria-label={`Search ${apiTitle}`}
        />

        {/* Controls */}
        <div className="popup-controls">
          <button type="button" className="btn-add" onClick={selectAll}>
            Select All
          </button>
          <button type="button" className="btn-remove" onClick={clearAll}>
            Clear All
          </button>
        </div>

        {/* Options */}
        <div className="popup-options">
          {loading ? (
            <p className="popup-status">Loading...</p>
          ) : filteredOptions.length > 0 ? (
            filteredOptions.map((item) => (
              <label key={item._id} className="checkbox-option">
                <input
                  type="checkbox"
                  checked={selected.includes(item._id)}
                  onChange={() => toggleSelect(item._id)}
                />
                <span>{getLabel(item)}</span>
              </label>
            ))
          ) : (
            <p className="popup-status">No options found.</p>
          )}
        </div>

        {/* Footer */}
        <footer className="popup-footer">
          <button type="button" className="btn-cancel" onClick={onClose}>
            Close
          </button>
        </footer>
      </div>
    </div>
  );
};

export default MultiSelectApiPopup;
